import { required, requiredIf, maxLength, minValue, helpers } from '@vuelidate/validators';
import i18n from "@/plugins/i18n";

export default {
  form: {
    name: {
      required: helpers.withMessage(i18n.global.t('Please enter a program name.'), required),
      maxLength: helpers.withMessage(
        ({ $params }) => i18n.global.t('Name cannot exceed') + ' ' + $params.max + ' ' + i18n.global.t('characters.'),
        maxLength(255)
      ),
    },
    code: {
      maxLength: helpers.withMessage(
        ({ $params }) => i18n.global.t('Code cannot exceed') + ' ' + $params.max + ' ' + i18n.global.t('characters.'),
        maxLength(50)
      ),
    },
    // earn_basis/earn_scope ตั้งไม่ได้แล้ว (บังคับ by_spend/all_eligible) → แต้มต่อบาทบังคับกรอกเสมอ
    point_per_baht: {
      required: helpers.withMessage(i18n.global.t('Please enter points per baht.'), required),
      minValue: helpers.withMessage(i18n.global.t('Value must be at least 0.'), minValue(0)),
    },
    expiry_mode: {
      required: helpers.withMessage(i18n.global.t('Please select an expiry mode.'), required),
    },
    expiry_date: {
      requiredIfFixed: helpers.withMessage(
        i18n.global.t('Please select an expiry date.'),
        requiredIf(function () { return this.form.expiry_mode === 'fixed_date'; })
      ),
    },
    expiry_months: {
      requiredIfRolling: helpers.withMessage(
        i18n.global.t('Please enter expiry months.'),
        requiredIf(function () { return this.form.expiry_mode === 'rolling'; })
      ),
      minValue: helpers.withMessage(i18n.global.t('Value must be at least 1.'), minValue(1)),
    },
    priority: {
      minValue: helpers.withMessage(i18n.global.t('Value must be at least 0.'), minValue(0)),
    },
  }
};
